import { useState, useEffect } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate } from "react-router-dom";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    // Array de imágenes disponibles
    const images = ["/pharmacy-01.jpg", "/pharmacy-02.jpg"];

    // Estado para guardar la imagen que se mostrará
    const [randomImage, setRandomImage] = useState("");

    // Al montar el componente, seleccionamos una imagen al azar
    useEffect(() => {
        const randomIndex = Math.floor(Math.random() * images.length);
        setRandomImage(images[randomIndex]);
    }, []); // Solo se ejecuta al montarse

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate("/dashboard");
        } catch (err) {
            setError("Error al iniciar sesión: " + err.message);
        }
    };

    return (
        <div data-theme="light" className="flex min-h-screen">
            {/* Sección Izquierda con imagen aleatoria */}
            <div className="w-1/2 h-screen">
                <img
                    src={randomImage}
                    alt="Farmacia"
                    className="w-full h-full object-cover"
                />
            </div>
            {/* Sección Derecha - Formulario de Login */}
            <div className="w-1/2 flex items-center justify-center">
                <div className="card w-full max-w-md bg-base-100">
                    <div className="card-body">
                        <div className="flex justify-center mb-4">
                            <img src="/logo-farmacia.png" alt="Logo" className="h-16" />
                        </div>
                        {error && (
                            <div className="alert alert-error shadow-lg mb-4">
                                <div>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="stroke-current flex-shrink-0 h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M18.364 5.636l-12.728 12.728M5.636 5.636l12.728 12.728"
                                        />
                                    </svg>
                                    <span>Error al iniciar sesión</span>
                                </div>
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="form-control mb-4">
                                <label className="label">
                                    <span className="label-text">Correo</span>
                                </label>
                                <input
                                    type="email"
                                    placeholder="correo@ejemplo.com"
                                    className="input input-bordered w-full"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-control mb-6">
                                <label className="label">
                                    <span className="label-text">Contraseña</span>
                                </label>
                                <input
                                    type="password"
                                    placeholder="********"
                                    className="input input-bordered w-full"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-control mt-6 flex justify-center">
                                <button className="btn btn-primary bg-[#2E8F42] border-none text-white w-full shadow-none">
                                    Ingresar
                                </button>
                            </div>
                        </form>

                        {/* "Powered by Xeroo" debajo de la tarjeta de login */}
                        <div className="flex items-center justify-center mt-4">
                            <span className="mr-2">Powered by</span>
                            <a
                                href="https://es.xeroo.ai/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img src="/xeroo-logo-grey.png" alt="Xeroo" className="h-3" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
